import React from "react";
import { Link } from "react-router-dom";

const cards = [
  {
    title: "Training Feedback",
    link: "/training-feedback",
  },
  {
    title: "Food Feedback",
    link: "/food-feedback",
  },
  {
    title: "Download Certificate",
    link: "/download-certificate",
  },
];

const LessonPlans = () => {
  return (
    <div
      id="content-page"
      className=""
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
      }}
    >
      {cards?.map((item, index) => {
        return (
          <Link
            to={
              item?.title == "Food Feedback"
                ? `/FoodFeedbackForm`
                : item?.title == "Download Certificate"
                  ? `/DownloadCertificate`
                  : item?.title == "Pre-Assessment"
                    ? `/assginMent`
                    : item?.title == "Pre-Training Feedback"
                      ? `/preTraningFeedback`
                      : `/ProgrammeDocuments`
            }
            // state={{ courses }}
            className="col-12 col-sm-6 col-xl-4"
          >
            <div>
              <div
                style={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "10px",
                  padding: "16px",
                  background: "#fff",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  // gap: "10px",
                  marginRight: "10px",
                  marginTop: "10px",
                  marginLeft: "10px",
                }}
              >
                <div
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    background: "#2e7d32",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "13px",
                  }}
                >
                  {index + 1}
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "10px",
                      color: "#bbb",
                      marginBottom: "2px",
                    }}
                  >
                    Step {index + 1}
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#222",
                    }}
                  >
                    {item?.title}
                  </div>
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#888",
                    lineHeight: "1.5",
                    flex: 1,
                  }}
                >
                  Evaluator reviews and scores your TOP after the training
                  session.
                </div>
              </div>
            </div>
          </Link>
        );
      })}
      {/* {isLoading
         ? <>
           <div
             className="d-flex justify-content-center "
             style={{ height: "85vh", paddingTop: "15vh" }}
           >
             <Oval
               height="50"
               width="50"
               color="#4fa94d"
               secondaryColor="#4fa94d"
             />
           </div>
         </>
         : (
           <>
             <ProfileHeader img={profilebg8} />
             <div
               id="content-page"
               className="content-inner store-details upcoming-card pt-4 mt-0"
             >
               <Container>
                 <Row>
                   <div
                     className="header-title mb-4"
                     style={{ textAlign: "left", width: "100%" }}
                   >
                     <h1
                       style={{
                         textAlign: "center",
                         width: "100%",
                       }}
                     >
                       About Program
                     </h1>
                   </div>
                   {isLoading
                     ? Array.from({ length: 2 }).map((_, index) => (
                       <Col sm="6" md="6" lg="4" key={index}>
                         <Skeleton height={250} className="rounded-3" />
                         <Skeleton height={20} width="80%" className="mt-2" />
                         <Skeleton height={15} width="90%" />
                         <Skeleton height={15} width="70%" />
                         <Skeleton height={15} width="50%" />
                       </Col>
                     ))
                     : courses?.map?.((item) => (
                       <Col sm="6" md="6" lg="4" key={item.id}>
                         <div className="mx-3">
                           <CourseCard course={item} />
                         </div>
                       </Col>
                     ))}
                 </Row>
               </Container>
             </div>
           </>
         )
       } */}
    </div>
  );
};

export default LessonPlans;

// import React from "react";
// import { Link } from "react-router-dom";

// const cards = [
//   {
//     title: "Training Feedback",
//     link: "/training-feedback",
//   },
//   {
//     title: "Food Feedback",
//     link: "/food-feedback",
//   },
//   {
//     title: "Download Certificate",
//     link: "/download-certificate",
//   },
// ];

// /* ---------- Small inline icon set (no extra deps) ---------- */
// const IconClipboard = (props) => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <rect x="8" y="2" width="8" height="4" rx="1" />
//     <path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2" />
//     <path d="M9 12h6M9 16h6" />
//   </svg>
// );
// const IconUtensils = (props) => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <path d="M7 2v20M3 2v6a4 4 0 0 0 8 0V2" />
//     <path d="M17 2c-2 2-3 4-3 8s1 6 3 8v4" />
//   </svg>
// );
// const IconAward = (props) => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <circle cx="12" cy="8" r="6" />
//     <path d="M8.21 13.89 7 22l5-3 5 3-1.21-8.11" />
//   </svg>
// );
// const IconArrowRight = (props) => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <path d="M5 12h14M13 5l7 7-7 7" />
//   </svg>
// );

// const cardIcons = [IconClipboard, IconUtensils, IconAward];
// const cardAccents = ["#16a34a", "#2563eb", "#d97706"];

// const LessonPlans = () => {
//   return (
//     <div
//       id="content-page"
//       className=""
//       style={{
//         display: "flex",
//         flexDirection: "row",
//         flexWrap: "wrap",
//         padding: "14px 8px 24px",
//       }}
//     >
//       {cards?.map((item, index) => {
//         const Icon = cardIcons[index % cardIcons.length];
//         const accent = cardAccents[index % cardAccents.length];

//         return (
//           <Link
//             key={index}
//             to={
//               item?.title == "Food Feedback"
//                 ? `/FoodFeedbackForm`
//                 : item?.title == "Download Certificate"
//                   ? `/DownloadCertificate`
//                   : item?.title == "Pre-Assessment"
//                     ? `/assginMent`
//                     : item?.title == "Pre-Training Feedback"
//                       ? `/preTraningFeedback`
//                       : `/ProgrammeDocuments`
//             }
//             // state={{ courses }}
//             className="col-12 col-sm-6 col-xl-4 lesson-plan-link"
//             style={{ textDecoration: "none" }}
//           >
//             <div>
//               <div
//                 className="lesson-plan-card"
//                 style={{
//                   border: "1px solid #ececec",
//                   borderRadius: "14px",
//                   padding: "18px",
//                   background: "#fff",
//                   height: "100%",
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: "10px",
//                   marginRight: "10px",
//                   marginTop: "10px",
//                   marginLeft: "10px",
//                   boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
//                   position: "relative",
//                   overflow: "hidden",
//                 }}
//               >
//                 <div
//                   style={{
//                     position: "absolute",
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     height: "4px",
//                     background: accent,
//                   }}
//                 />

//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                   }}
//                 >
//                   <div
//                     style={{
//                       width: "38px",
//                       height: "38px",
//                       borderRadius: "50%",
//                       background: accent,
//                       color: "#fff",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       fontWeight: "700",
//                       fontSize: "14px",
//                       boxShadow: `0 4px 10px ${accent}55`,
//                     }}
//                   >
//                     {index + 1}
//                   </div>
//                   <div
//                     style={{
//                       width: "32px",
//                       height: "32px",
//                       borderRadius: "9px",
//                       background: `${accent}15`,
//                       color: accent,
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                     }}
//                   >
//                     <Icon />
//                   </div>
//                 </div>

//                 <div>
//                   <div
//                     style={{
//                       fontSize: "10.5px",
//                       color: "#aaa",
//                       marginBottom: "3px",
//                       letterSpacing: "0.4px",
//                       textTransform: "uppercase",
//                       fontWeight: "600",
//                     }}
//                   >
//                     Step {index + 1}
//                   </div>
//                   <div
//                     style={{
//                       fontSize: "15px",
//                       fontWeight: "700",
//                       color: "#1f2328",
//                     }}
//                   >
//                     {item?.title}
//                   </div>
//                 </div>

//                 <div
//                   style={{
//                     fontSize: "12.5px",
//                     color: "#8a8f98",
//                     lineHeight: "1.55",
//                     flex: 1,
//                   }}
//                 >
//                   Evaluator reviews and scores your TOP after the training
//                   session.
//                 </div>

//                 <div
//                   className="lesson-plan-cta"
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "6px",
//                     fontSize: "12.5px",
//                     fontWeight: "600",
//                     color: accent,
//                     marginTop: "2px",
//                   }}
//                 >
//                   Continue
//                   <IconArrowRight />
//                 </div>
//               </div>
//             </div>
//           </Link>
//         );
//       })}
//       {/* {isLoading
//          ? <>
//            <div
//              className="d-flex justify-content-center "
//              style={{ height: "85vh", paddingTop: "15vh" }}
//            >
//              <Oval
//                height="50"
//                width="50"
//                color="#4fa94d"
//                secondaryColor="#4fa94d"
//              />
//            </div>
//          </>
//          : (
//            <>
//              <ProfileHeader img={profilebg8} />
//              <div
//                id="content-page"
//                className="content-inner store-details upcoming-card pt-4 mt-0"
//              >
//                <Container>
//                  <Row>
//                    <div
//                      className="header-title mb-4"
//                      style={{ textAlign: "left", width: "100%" }}
//                    >
//                      <h1
//                        style={{
//                          textAlign: "center",
//                          width: "100%",
//                        }}
//                      >
//                        About Program
//                      </h1>
//                    </div>
//                    {isLoading
//                      ? Array.from({ length: 2 }).map((_, index) => (
//                        <Col sm="6" md="6" lg="4" key={index}>
//                          <Skeleton height={250} className="rounded-3" />
//                          <Skeleton height={20} width="80%" className="mt-2" />
//                          <Skeleton height={15} width="90%" />
//                          <Skeleton height={15} width="70%" />
//                          <Skeleton height={15} width="50%" />
//                        </Col>
//                      ))
//                      : courses?.map?.((item) => (
//                        <Col sm="6" md="6" lg="4" key={item.id}>
//                          <div className="mx-3">
//                            <CourseCard course={item} />
//                          </div>
//                        </Col>
//                      ))}
//                  </Row>
//                </Container>
//              </div>
//            </>
//          )
//        } */}

//       {/* Scoped UI polish (visual only, no logic change) */}
//       <style>{`
//         .lesson-plan-link {
//           display: block;
//         }
//         .lesson-plan-card {
//           transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
//         }
//         .lesson-plan-link:hover .lesson-plan-card {
//           transform: translateY(-4px);
//           box-shadow: 0 10px 24px rgba(0,0,0,0.08);
//           border-color: #e0e0e0;
//         }
//         .lesson-plan-cta svg {
//           transition: transform 0.2s ease;
//         }
//         .lesson-plan-link:hover .lesson-plan-cta svg {
//           transform: translateX(3px);
//         }
//       `}</style>
//     </div>
//   );
// };

// export default LessonPlans;
